import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

// Single type toggle card — Billed or Unbilled
const TypeCard = ({ label, sub, active, onClick }) => {
  const theme = useTheme();
  const t = theme.custom;

  return (
    <Box
      onClick={onClick}
      sx={{
        flex: 1, padding: "10px 12px", borderRadius: "3px",
        cursor: "pointer", transition: "all 0.15s",
        border: active ? `1px solid ${t.accent}88` : `1px solid ${t.border2}`,
        background: active ? t.accent2 : t.surface2,
      }}
    >
      <Typography sx={{
        fontSize: "12px", fontWeight: 600,
        color: active ? t.accent : t.text2,
        fontFamily: "'Inter', sans-serif",
      }}>
        {label}
      </Typography>
      <Typography sx={{
        fontFamily: "'DM Mono', monospace",
        fontSize: "9px", color: t.text3, mt: "2px",
      }}>
        {sub}
      </Typography>
    </Box>
  );
};

export default TypeCard;